<template>
  <section class="well" aria-labelledby="unsigned-lessons-heading">
    <h2 id="unsigned-lessons-heading">Sign your previous lessons</h2>
    <p>Please sign your previous driving lessons before booking another lesson.</p>
    <ul class="unsigned-lessons">
      <li v-for="lesson in lessons" :key="lesson.id">
        <span>{{ lesson.type_name }} · {{ lessonDate(lesson) }}</span>
        <a :href="lesson.url" class="btn btn-dc">Review and sign</a>
      </li>
    </ul>
  </section>
</template>

<script>
import { formatDateTime } from "../../common/helpers/time";

export default {
  name: "UnsignedLessonsNotice",
  props: {
    lessons: { type: Array, default: () => [] },
  },
  methods: {
    lessonDate(lesson) {
      return formatDateTime(
        new Date(`${lesson.drive_date}T${lesson.start_time}`),
        "MM/DD/YYYY h:mm A"
      );
    },
  },
};
</script>

<style scoped>
.unsigned-lessons {
  list-style: none;
  padding: 0;
  margin: 0;
}

.unsigned-lessons li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #ddd;
}
</style>
